//Libs
import React, { Component } from 'react';
import PropTypes from 'prop-types';
//Componentes material
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
//Models
import AvaliacaoResposta from '../../models/AvaliacaoResposta';

/**
 * Componente para renderizar um campo para responder uma questão do tipo texto
 */
class AvaliacaoRespostaTexto extends Component {
    constructor(props) {
        super(props);
        //Binding
        this.handleRespostaChange = this.handleRespostaChange.bind(this);
    }

    /**
     * Evento disparado quando o campo é alterado
     * @param {*} event Dados do evento
     */
    handleRespostaChange(event) {
        const questao = AvaliacaoResposta.clone(this.props.questao);
        questao.resposta = event.target.value;
        if (this.props.onChange)
            this.props.onChange(questao);

    }

    render() {

        /** @type {AvaliacaoResposta} */
        const questao = this.props.questao;
        const erro = this.props.erro;
        
        //Identificando mensagem de erro (Erro geral tem preferência)
        let mensagemErro = '';
        if (erro.erroResposta)
            mensagemErro = erro.erroResposta;
        else 
            mensagemErro = erro.resposta;

        return (
            <Grid item xs={12} >
                <TextField
                    label={questao.titulo} 
                    type="text" 
                    placeholder={questao.titulo} 
                    variant="outlined" 
                    size="small"
                    fullWidth 
                    onChange={this.handleRespostaChange}
                    required={questao.obrigatoria}
                    value={questao.resposta ?? ''} 
                    error={!!mensagemErro}
                    helperText={mensagemErro}
                />
            </Grid>
        );
    }
}

AvaliacaoRespostaTexto.propTypes = {
    /** Objeto contendo os dados da questão a ser respondida */
    questao: PropTypes.instanceOf(AvaliacaoResposta).isRequired,
    /** Evento disparado quando a resposta for alterada */
    onChange: PropTypes.func,
    /** Mensagens de erro da resposta */
    erro: PropTypes.shape({ 
        resposta: PropTypes.string,
        erroResposta: PropTypes.string
    }),
};

AvaliacaoRespostaTexto.defaultProps = {
    erro: {
        resposta: '',
        erroResposta: ''
    }
};

export default AvaliacaoRespostaTexto;